import { dateUtils } from '@festina-life/core'
import { Button, CopyToClipboard } from '@festina-life/ui/actions'
import { CircularSpinner } from '@festina-life/ui/feedback'
import { useTranslate } from '@festina-life/ui/hooks'
import { withSuspense } from '@festina-life/ui/libs'
import {
  Card,
  CardBody,
  CardItem,
  SimpleModal,
} from '@festina-life/ui/structure'
import { useState } from 'react'

import { withLifeErrorBoundary } from '../../libs/withLifeErrorBoundary'
import {
  type StackTraceSupportedComponent,
  useFetchStackTrace,
} from './useFetchStackTrace'

type Props = {
  stopStackTraceId: string
  component: StackTraceSupportedComponent
}

const StopStackTraceInternal = ({ stopStackTraceId, component }: Props) => {
  const translate = useTranslate()

  const [isModalOpen, setIsModalOpen] = useState(false)

  const { data: stackTrace } = useFetchStackTrace({
    stopStackTraceId,
    component,
  })

  return stackTrace ? (
    <>
      <Button
        onClick={(e) => {
          e.stopPropagation()
          e.preventDefault()
          setIsModalOpen(true)
        }}
      >
        {translate('stopEvents.stackTraceDetails')}
      </Button>

      <SimpleModal
        isOpen={isModalOpen}
        SecondaryFooterAction={
          <CopyToClipboard copyValue={JSON.stringify(stackTrace, null, 2)} />
        }
        title={translate('stopEvents.stackTraceDetails')}
        closeConfiguration={{
          onClose: () => setIsModalOpen(false),
        }}
      >
        <Card className="self-start">
          <CardBody>
            <CardItem
              title={translate('stopEvents.applicationVersion')}
              value={stackTrace.applicationVersion}
              isHiddenWithNoData
            />
            <CardItem
              title={translate('stopEvents.configurationVersionNumber')}
              value={stackTrace.configurationVersionNumber}
              isHiddenWithNoData
            />
            <CardItem
              title={translate('stopEvents.creationStamp')}
              value={dateUtils.dateWithTimeAsStr(stackTrace.creationStamp)}
              isHiddenWithNoData
            />
          </CardBody>
        </Card>
        <pre>{stackTrace.stackTrace}</pre>
      </SimpleModal>
    </>
  ) : null
}

export const StopStackTrace = withLifeErrorBoundary(
  withSuspense(StopStackTraceInternal, {
    fallback: <CircularSpinner />,
  }),
)
